import { createSelector } from 'reselect';
import { selectors } from './';

export const selectIncidentReport = createSelector(
  selectors,
  (_, incidentReportID) => incidentReportID,
  ({ info }, incidentReportID) => {
    return info[incidentReportID] || {};
  }
);

export const selectIncidentPdfReportLink = createSelector(
  selectors,
  (_, incidentReportID) => incidentReportID,
  ({ reportLinks }, incidentReportID) => {
    return reportLinks[incidentReportID];
  }
);
